import React from 'react'

import compose   from 'vegas-js-core/src/functors/compose'
import isBoolean from 'vegas-js-core/src/isBoolean'

import initApp from '../../../../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import CourseIcon from '@material-ui/icons/Map'

import identify      from '../../../../../things/identify'
import PropertyValue from '../../../../../things/PropertyValue'
import Course        from '../../../../../things/Course'

import ThingOrderableChildren, { styles } from '../../../ThingOrderableChildren'

const prepare = ( action = null ) => item =>
{
    const {
        subjectOf,
        value
    } = item ;

    let agenda ;
    let courses ;
    let events ;
    let game ;
    let version ;

    if( subjectOf )
    {
        const {
            agenda  : a,
            courses : c,
            events  : e,
            game    : g ,
            version : v
        } = subjectOf ;

        if( isBoolean(a) )
        {
            agenda = a ;
        }

        if( c )
        {
            courses = c ;
        }

        if( e )
        {
            events = e ;
        }

        if( g )
        {
            game = g ;
        }

        if( v )
        {
            version = v ;
        }
    }

    courses = identify( courses ) ;
    events  = identify( events ) ;
    game    = identify( game ) ;

    switch( action )
    {
        case 'add' :
        {
            courses.unshift( value.id.toString() ) ;
            break ;
        }
        case 'remove' :
        {
            courses = courses.filter( id => id !== item.id.toString() ) ;
            break ;
        }
        default :
        {
            //
        }
    }

    const setting = {
        agenda,
        courses,
        events,
        game,
        version
    };

    return ({ setting : JSON.stringify( setting ) });
};

class Courses extends ThingOrderableChildren
{
    getLocale = () => this.props.locale.things.application.settings.ambulo.courses ;

    onAdd    = this.change ;
    onRemove = this.change ;

    addPrepare    = prepare('add') ;
    removePrepare = prepare('remove') ;

    orderPrepare  = ( { ordered } = {} ) =>
    {
        const { thing } = this.props ;
        if( thing )
        {
            let {
                agenda,
                courses,
                events,
                game,
                version
            } = thing ;

            if( ordered )
            {
                courses = ordered ;
            }

            courses = identify( courses ) ;
            events  = identify( events ) ;
            game    = identify( game ) ;

            let setting =
            {
                agenda,
                courses,
                events,
                game,
                version
            };

            return { setting : JSON.stringify( setting ) } ;
        }
    };

}

Courses.defaultProps =
{
    ...ThingOrderableChildren.defaultProps ,
    clazz      : Course,
    emptyClazz : PropertyValue,
    icon       : <CourseIcon/> ,
    member     : 'courses',
    orderMock  : false
};

Courses.propTypes =
{
    ...ThingOrderableChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( Courses ) ;
